import React from 'react';
import { pricingPlans } from '../data/mockData';
import { Button } from './ui/button';
import { Check, Star } from 'lucide-react';

const PricingSection = ({ onOpenContactForm }) => {
  return (
    <section id="pricing" className="py-24 bg-cream-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-wine-500 mb-3">Pricing Plans</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-wine-950 mb-4">
            Transparent <span className="text-wine-600">Filing Packages</span>
          </h2>
          <p className="text-stone-500">Clear pricing for every level. All packages exclude USPTO filing fees ($250-$350 per class).</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {pricingPlans.map((plan) => (
            <div key={plan.id} data-testid={`pricing-card-${plan.name.toLowerCase()}`}
              className={`relative flex flex-col bg-white rounded-xl overflow-hidden h-[480px] ${plan.recommended ? 'border-2 border-wine-600 shadow-xl shadow-wine-600/10 ring-1 ring-wine-600/20' : 'border border-stone-200'} hover:-translate-y-1 hover:shadow-xl hover:shadow-gold-500/10 hover:border-gold-400 transition-all duration-300`}>
              {plan.recommended && (
                <div className="bg-wine-600 text-white text-center py-1.5 text-xs font-bold flex items-center justify-center gap-1 flex-shrink-0">
                  <Star className="w-3 h-3 fill-gold-400 text-gold-400" /> RECOMMENDED
                </div>
              )}
              <div className="p-6 text-center border-b border-stone-100 flex-shrink-0">
                <h3 className="text-lg font-bold text-wine-950 mb-2">{plan.name}</h3>
                <span className="text-3xl font-bold text-wine-950">{plan.price}</span>
                <p className="text-xs text-stone-400 mt-1">{plan.federal}</p>
              </div>
              <div className="flex-1 p-6 overflow-y-auto scrollbar-thin">
                <ul className="space-y-3">
                  {plan.features.map((f, i) => (
                    <li key={i} className="flex items-start"><Check className="w-4 h-4 text-wine-600 mr-2 flex-shrink-0 mt-0.5" /><span className="text-sm text-stone-600">{f}</span></li>
                  ))}
                </ul>
              </div>
              <div className="p-6 border-t border-stone-100 flex-shrink-0">
                <p className="text-xs text-stone-400 text-center mb-3">{plan.note}</p>
                <Button data-testid={`pricing-btn-${plan.name.toLowerCase()}`} onClick={onOpenContactForm}
                  className={`w-full font-medium transition-all ${plan.recommended ? 'bg-wine-600 hover:bg-wine-700 text-white' : 'bg-stone-100 hover:bg-gold-500 hover:text-wine-950 text-stone-800'}`}>
                  {plan.buttonText}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
